.root {
  flex: 1;
  overflow-y: auto;
  background: var(--color-surface-subtle);
}

.inner {
  max-width: var(--content-max-width);
  margin: 0 auto;
  padding: 32px clamp(16px, 4vw, 48px) 56px;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-border);
}

.titleRow {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.iconWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  background: var(--color-brand-primary-soft);
  flex-shrink: 0;
}

.icon {
  font-size: 22px;
  color: var(--color-brand-primary);
}

.title {
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.01em;
}

.subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin-top: 4px;
  max-width: 560px;
  line-height: 1.5;
}

.cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--color-brand-primary);
  background: var(--color-surface);
  color: var(--color-brand-primary);
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);
  flex-shrink: 0;
}

.cta:hover {
  background: var(--color-brand-primary);
  color: var(--color-text-on-brand);
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
